<template>
  <async-btn
    :task="task"
    label="Resend Code"
    class="full-width"
    @click="resend"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import notify from '@/components/notify';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { mfaResendPin } from './auth';

interface Data {
  task: Promise<void>|null
}

export default defineComponent({
  components: { AsyncBtn },
  props: {
    email: {
      type: String,
      required: true,
    },
    password: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    resend() {
      this.task = mfaResendPin(this.email, this.password);
      this.task.then(() => {
        notify({
          color: 'positive',
          message: 'Login code has been emailed to you.',
        });
      });
    },
  },
});
</script>
